export default {
    getGiftDetails : state => state.giftDetails
}